export default "__VITE_ASSET__BbZZJuNh__"